import React from 'react'
 import { Link } from 'react-router-dom'
export default function seocourse() {
  return (
    <>
       <main>
        
        <div className="hero-arera course-item-height" data-background="assets/img/slider/course-slider.jpg" style={{backgroundImage:" url(assets/img/slider/seoimage.jpg)"}}>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="hero-course-1-text">
                            <h2> SEO Course </h2>
                        </div>
                        <div className="course-title-breadcrumb">
                            <nav>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><span>Courses</span></li>
                                    <li className="breadcrumb-item active" aria-current="page">SEO Course</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
        <section className="course-detalis-area pb-90">
            <div className="container">
                <div className="row">
                    <div className=" col-xxl-8 col-xl-8">
                        <div className="course-detalis-wrapper mb-30">
                            <div className="course-heading mb-20">
                                <h2>Advanced SEO Training Institute in Dewas</h2>
                                <div className="course-star">
                                    <ul>
                                        <li><i className="fas fa-star"></i></li>
                                    </ul>
                                    <ul>
                                        <li><i className="fas fa-star"></i></li>
                                    </ul>
                                    <ul>
                                        <li><i className="fas fa-star"></i></li>
                                    </ul>
                                    <ul>
                                        <li><i className="fas fa-star"></i></li>
                                    </ul>
                                    <ul>
                                        <li><i className="fal fa-star"></i></li>
                                    </ul>
                                    <span>(254 reviews)</span>
                                </div>
                            </div>
                         
                            <div className="course-description pt-45 pb-30">
                                <div className="course-Description">
                                    <h4>Description</h4>
                                </div>
                                <p>The training of search engine optimization enables one to establish a positive and long term result by promoting their product or services online. This can be achieved by doing optimization in a two-way process that is on-page and off-page SEO for a landing page or website</p>
                            </div>
                            <div className="course-learn-wrapper">
                                <div className="course-learn">
                                    <div className="course-leranm-tittle">
                                        <h4 className="mb-15">What you'll learn</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="course-leran-text f-left">
                                                <ul>
                                                    <li>To advertise or promote your website/blog.</li>
                                                    <li>To prepare yourself for job interview.</li>
                                              
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-xl-6">
                                            <div className="course-leran-text">
                                                <ul>
                                                    <li>Include an extra skill in your CV/Resume.</li>
                                                    <li>Begin a profession as SEO Expert.</li>
                                                
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                 
                     
                        </div>
                    </div>




                    <div className="col-xxl-4 col-xl-4 col-lg-8 col-md-8">
                        <div className="course-video-widget">
                            <div className="course-widget-wrapper mb-30">
                                <div className="course-video-thumb w-img">
                                    <img src="assets/img/course/course-video.png" alt="image not found"/>
                                    <div className="sidber-video-btn">
                                        <a className="popup-video" href="https://www.youtube.com/watch?v=F68sQYaS9XA"><i
                                                className="fas fa-play"></i></a>
                                    </div>
                                </div>
                                <div className="course-video-price">
                                    <span>$147.00</span>
                                </div>
                                <div className="course-video-body">
                                    <ul>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-filter"></i>
                                                <span>Level</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>Beginners</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-computer"></i>
                                                <span>Lectures</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>8 Lectures</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-clock"></i>
                                                <span>Duration</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>1h 30m 12s</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-menu-2"></i>
                                                <span>Category</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>Data Science</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-global"></i>
                                                <span>Laguage</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>English</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-bookmark-white"></i>
                                                <span>Access</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>Full Lifetime</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-award"></i>
                                                <span>Certificate</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>Yes </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="course-vide-icon">
                                                <i className="flaticon-list"></i>
                                                <span>Recourse</span>
                                            </div>
                                            <div className="video-corse-info">
                                                <span>5 Downloadable Files </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="video-wishlist">
                                <Link className="edo-course-sec-btn"  to="https://wa.me/9617124507">Apply now</Link>
                                
                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </main>
    
    
    
    </>
  )
}
